import { Box } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledSampleTrackingFilter = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: '$borderWidths$1 solid $colors$seafoam500',
  marginBottom: '$4',
  padding: '$10 $6 $4 $6',
});

export const StyledDropdownFilters = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '$4',
});
